


























































import { Component, Vue } from 'vue-property-decorator'
import axiosInstance from '@/plugins/axios'
import { showHttpErrorAlert } from '@/plugins/helper'
import AppNavDrawer from '@/components/AppNavDrawer.vue'

@Component({
  components: {
    AppNavDrawer
  }
})
export default class PageViewHealthProfiles extends Vue {
  headers = [
    { text: 'Profile ID', value: 'profileId' },
    { text: 'Customer', value: 'customer' },
    { text: 'First Name', value: 'firstName' },
    { text: 'Last Name', value: 'lastName' },
    { text: 'Gender', value: 'gender' },
    { text: 'Birth Date', value: 'dob' },
    { text: 'Tel', value: 'tel' },
    { text: 'Document', value: 'document' },
    { text: 'Document Photo', value: 'documentPhotos' },
    { text: 'Created At', value: 'createdAt' },
    { text: 'Active at', value: 'activeAt' }
  ]

  items = []
  isLoadingItems = false

  created () {
    this.fetchHealthProfiles()
  }

  async fetchHealthProfiles () {
    try {
      this.isLoadingItems = true
      const { data } = await axiosInstance.get('/portal/insurance/health-profiles')
      this.items = data.data.map((item: any) => {
        return {
          profileId: item.profile_id,
          customerUuid: item.customer_uuid,
          customerName: item.customer_name,
          customerTel: item.customer_tel,
          firstName: item.first_name,
          lastName: item.last_name,
          gender: item.gender,
          dob: item.dob,
          tel: item.tel,
          documentType: item.document_type,
          documentId: item.document_id,
          documentPhotos: item.document_photos,
          createdAt: item.created_at,
          activeAt: item.active_at
        }
      })
      this.isLoadingItems = false
    } catch (error) {
      this.isLoadingItems = false
      showHttpErrorAlert(error)
    }
  }
}
